export default __webpack_public_path__ + "static/media/skeleton_graffiti.4d4f4e07.jpg";